// Generated by ReScript, PLEASE EDIT WITH CARE

import * as CssJs from "bs-css-emotion/src/CssJs.bs.js";
import * as React from "react";
import * as Global from "common/src/Global.bs.js";
import * as LlIcon from "../components/LlIcon.bs.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as WrappedSectionHeader from "./WrappedSectionHeader.bs.js";

function WrappedCompanionStats(Props) {
  var uniqueCompanions = Props.uniqueCompanions;
  var companionStats = Props.companionStats;
  return React.createElement("div", {
              className: "pt-16"
            }, React.createElement(WrappedSectionHeader.make, {
                  title: "Tacticians"
                }), React.createElement("div", {
                  className: "pb-2"
                }, "You have been represented by ", React.createElement("span", {
                      className: "wrapped-num text-primary-11"
                    }, String(uniqueCompanions)), " different tacticians and these were your favorites:"), React.createElement("div", {
                  className: CssJs.style([
                        CssJs.display(CssJs.grid),
                        CssJs.gridAutoFlow(CssJs.column),
                        CssJs.gridTemplateColumns([
                              CssJs.px(100),
                              {
                                NAME: "repeat",
                                VAL: [
                                  {
                                    NAME: "num",
                                    VAL: 5
                                  },
                                  CssJs.px(100)
                                ]
                              }
                            ]),
                        CssJs.gridTemplateRows([{
                                NAME: "repeat",
                                VAL: [
                                  {
                                    NAME: "num",
                                    VAL: 3
                                  },
                                  CssJs.auto
                                ]
                              }]),
                        CssJs.alignItems(CssJs.center),
                        CssJs.unsafe("justifyItems", "center"),
                        CssJs.unsafe("boxShadow", "0 4px 2px -2px rgb(0 0 0 / 40%)")
                      ])
                }, React.createElement("div", undefined), React.createElement("div", undefined, "Games"), React.createElement("div", {
                      className: "pb-1"
                    }, "Avg. Place"), Belt_Array.mapWithIndex(Belt_Array.slice(companionStats, 0, 5), (function (idx, param) {
                        var contentId = param[0];
                        return React.createElement(React.Fragment, {
                                    children: null,
                                    key: contentId
                                  }, React.createElement("div", {
                                        className: "w-full flex justify-center py-2" + (
                                          idx % 2 === 0 ? " bg-bg2" : ""
                                        )
                                      }, React.createElement(LlIcon.make, {
                                            companionId: contentId,
                                            size: 68
                                          })), React.createElement("div", {
                                        className: "w-full text-center " + (
                                          idx % 2 === 0 ? " bg-bg2" : ""
                                        )
                                      }, String(param[1])), React.createElement("div", {
                                        className: "w-full pb-1 text-center" + (
                                          idx % 2 === 0 ? " bg-bg2" : ""
                                        )
                                      }, Global.toFixed(undefined, param[2])));
                      }))));
}

var make = WrappedCompanionStats;

export {
  make ,
  
}
/* CssJs Not a pure module */
